{
  "navigation": {
    "products": "Our Products",
    "pricing": "Pricing",
    "testimonials": "Reviews",
    "blog": "Blog",
    "freeQuote": "Free Quote",
    "tagline": "Memory Creator"
  },
  "header": {
    "title": "Create Your Trendy Yearbook",
    "subtitle": "Gather, tell, relive.",
    "description": "Capture this school year in a personalized photo book, created by you. A collection of memories, laughter, and emotions, to keep forever or to give as a gift.",
    "formTitle": "Get Your Free Quote",
    "formName": "Name",
    "formEmail": "Email",
    "formPhone": "Phone",
    "formOrganization": "School/Organization",
    "formSubmit": "Get My Quote",
    "formSubmitting": "Sending...",
    "formMessage": "Describe your project...",
    "formQuoteDelay": "(Quote within 24h)",
    "downloadEbook": "Download our free ebook",
    "partnerSchools": "Partner schools",
    "madeInFrance": "Made in France",
    "counters": {
      "yearbooks": "yearbooks already created",
      "satisfaction": "satisfied customers",
      "years": "years of experience"
    }
  },
  "services": {
    "title": "Create Your Yearbook in 3 Steps",
    "subtitle": "Transform your memories into a unique book.",
    "subtitleBreak": "Simple, fast, and personalized.",
    "step1": {
      "title": "Choose",
      "description": "Select your package and customize your yearbook according to your wishes"
    },
    "step2": {
      "title": "Upload",
      "description": "Import your photos and let the magic happen with our intuitive editor"
    },
    "step3": {
      "title": "Receive",
      "description": "Receive your printed yearbooks directly at your school"
    },
    "learnMore": "Learn more about the process"
  },
  "products": {
    "title": "Discover Our Yearbooks",
    "subtitle": "Formats adapted to all budgets, from kindergarten to university.",
    "from": "Starting at",
    "perUnit": "/ unit",
    "details": "View details",
    "popular": "Popular",
    "degressivePricing": "Degressive pricing is applied based on quantity.",
    "miniBudget": {
      "title": "Mini-Budget",
      "subtitle": "For schools & high schools",
      "description": "The essentials to keep your memories"
    },
    "classic": {
      "title": "Classic",
      "subtitle": "For universities",
      "description": "The best value for money"
    },
    "premium": {
      "title": "Premium",
      "subtitle": "For associations & companies",
      "description": "For exceptional memories"
    },
    "features": {
      "pages20to32": "20 to 32 pages",
      "stapled": "Stapled",
      "priceFor150": "Price shown for an order of 150 copies",
      "from36pages": "From 36 pages",
      "softCover": "Soft cover",
      "squareBack": "Square back glued",
      "from32pages": "From 32 pages",
      "hardCover": "Hardcover cardboard"
    }
  },
  "pricing": {
    "title": "Custom Creative Support!",
    "subtitle": "Clear design packages, adapted to everyone according to the desired creative support.",
    "evolveOffer": "You can upgrade your offer during the project!",
    "bestSeller": "Best Seller",
    "essential": {
      "name": "Essential",
      "subtitle": "Your Yearbook\nin just a few clicks! 💪",
      "description": "An intuitive platform rich in design for your creativity!",
      "price": "Free"
    },
    "serenity": {
      "name": "Serenity",
      "subtitle": "A perfect Yearbook with the help of our expert Graphic Designers 🧑‍🎨",
      "description": "In-depth graphic support with our design experts!",
      "price": "€450"
    },
    "custom": {
      "name": "Custom",
      "subtitle": "A custom Yearbook according to your wishes 🎨",
      "description": "The creation of your Yearbook\nfrom A to Z by our experts!",
      "price": "€1150"
    },
    "features": {
      "followUp": "Follow-up Support",
      "editor": "Yearbook Editor",
      "designsStickers": "(250+ designs & 1500 stickers)",
      "graphistExchanges": "Graphic designer exchange(s)",
      "digitalYearbook": "Digital Yearbook",
      "customCreation": "Custom creation",
      "cover": "Cover",
      "interior": "Interior",
      "trombi": "Class photo",
      "bonusUpload": "Bonus: Upload your content",
      "yes": "Yes",
      "no": "No"
    },
    "chooseFormula": "Choose this plan"
  },
  "demos": {
    "title": "Our examples",
    "titleHighlight": "of creations",
    "subtitle": "Discover our creations for each school level.",
    "viewYearbook": "View yearbook",
    "filters": {
      "all": "All",
      "primary": "Elementary",
      "middle": "Middle School",
      "high": "High School",
      "university": "University"
    }
  },
  "testimonials": {
    "title": "They Trust Us",
    "subtitle": "Discover testimonials from our satisfied customers.",
    "whatTheySay": "What they say about us",
    "clientTypes": {
      "engineeringSchool": "Engineering school",
      "businessSchool": "Business school",
      "europeanSchool": "European school",
      "internationalSchool": "International school",
      "establishment": "Establishment",
      "citySchool": "City School",
      "school": "School",
      "politicalScience": "Political science school",
      "midwiferySchool": "Midwifery school",
      "universityInstitute": "University institute",
      "managementSchool": "Management school",
      "company": "Company",
      "foundation": "Foundation",
      "event": "Event",
      "hospitality": "Hospitality",
      "fashion": "Fashion",
      "union": "Union"
    }
  },
  "team": {
    "title": "Our Team",
    "subtitle": "A committed team always listening to you.",
    "members": {
      "hubert": {
        "role": "Founder",
        "description": "Hubert, a passionate entrepreneur, founded 1Year1Book in France with the dream of democratizing the world of Yearbooks and creating unforgettable memories."
      },
      "lynda": {
        "role": "Sales Team",
        "description": "Lynda supports you with kindness in implementing your Yearbook projects. Listening to your needs, she does everything to ensure their success."
      },
      "charlotteB": {
        "role": "Communication Team",
        "description": "Creative, Shaima develops our brand image by setting up strategic partnerships to increase our visibility, while creating content that fully enhances the Yearbook."
      },
      "raphaelle": {
        "role": "Customer Relations",
        "description": "Attentive and responsive, Raphaëlle guarantees you an exceptional customer experience at every stage of your project."
      },
      "charlotteR": {
        "role": "Design Team",
        "description": "Charlotte offers unique designs that transform each Yearbook into a personalized work of art."
      },
      "cedric": {
        "role": "Tech Team",
        "description": "He is 1Year1Book's technical expert. Cédric ensures we stay at the forefront of technology to always offer you modern and innovative solutions."
      }
    }
  },
  "yearbookGallery": {
    "title": "Yearbooks for everyone!",
    "subtitle": "Explore our inspiring examples, adapted to all ages and occasions.",
    "viewCatalogue": "View our catalogue",
    "categories": {
      "primary": "Elementary Schools",
      "middle": "Middle Schools",
      "high": "High Schools",
      "university": "Universities and Graduate Schools",
      "leisureCenter": "Leisure Centers",
      "camps": "Summer Camps"
    },
    "categoryDescriptions": {
      "primary": "Yearbooks specially designed for elementary schools with colorful and fun designs.",
      "middle": "Modern yearbooks adapted for middle schoolers with dynamic layouts.",
      "high": "Elegant yearbooks to immortalize high school years in style.",
      "university": "Professional yearbooks for graduate schools and universities.",
      "leisureCenter": "Fun and colorful yearbooks for leisure centers and after-school activities.",
      "camps": "Unforgettable summer camp memories in a unique format."
    },
    "features": {
      "childDesign": "Child-friendly design",
      "colorfulPages": "Colorful pages",
      "resistantFormat": "Resistant format",
      "activitiesIncluded": "Activities included",
      "modernLayout": "Modern layout",
      "classPhotos": "Class photos",
      "socialPages": "Social media pages",
      "activitiesSection": "Activities section",
      "elegantDesign": "Elegant design",
      "seniorYear": "Senior year",
      "promSection": "Prom section",
      "alumniDirectory": "Alumni directory",
      "professionalFormat": "Professional format",
      "alumniSection": "Alumni section",
      "careerPages": "Career pages",
      "eventCoverage": "Event coverage",
      "funDesign": "Fun design",
      "activityPhotos": "Activity photos",
      "groupPages": "Group pages",
      "memoriesSection": "Memories section",
      "adventureDesign": "Adventure design",
      "campPhotos": "Camp photos",
      "adventurePages": "Adventure pages",
      "friendsSection": "Friends section"
    },
    "viewCatalogue": "View catalogue"
  },
  "footer": {
    "contactForm": "Contact Form",
    "launchNow": "Get started now!",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "message": "Message",
    "send": "Send",
    "sending": "Sending...",
    "contactInfo": "Contact Information",
    "address": "Address",
    "followUs": "Follow Us",
    "hours": "Hours",
    "hoursValue": "Mon - Fri: 9am - 6pm",
    "weekendClosed": "Saturday / Sunday",
    "closed": "Closed",
    "legalLinks": "Legal Links",
    "legalNotice": "Legal Notice",
    "privacy": "Privacy Policy",
    "terms": "Terms & Conditions",
    "faq": "FAQ",
    "copyright": "All rights reserved."
  },
  "common": {
    "loading": "Loading...",
    "error": "Error",
    "success": "Success",
    "close": "Close",
    "submit": "Submit",
    "cancel": "Cancel",
    "previous": "Previous",
    "next": "Next",
    "fillRequired": "Please fill in all required fields."
  },
  "thankYou": {
    "title": "Thank You!",
    "message": "Your request has been sent successfully. We will contact you shortly."
  },
  "quote": {
    "title": "Quote Request",
    "selectFormula": "Select a plan",
    "quantity": "Estimated number of copies",
    "establishment": "School/Organization",
    "level": "School level",
    "levels": {
      "primary": "Elementary",
      "middle": "Middle School",
      "high": "High School",
      "university": "University",
      "other": "Other"
    }
  },
  "cse": {
    "solutionBadge": "CSE Solution",
    "heroTitle": "BAI – Individual Activity Report",
    "heroDescription": "1Year1Book helps Works Councils create their BAI, a personalized document given to each employee to highlight the benefits provided.",
    "launchButton": "Get Started!",
    "baiDistributed": "BAIs distributed",
    "whatIsBai": "What is the BAI?",
    "whatIsBaiDescription": "The BAI summarizes, in a clear, graphical and quantified manner, all the benefits granted by the Works Council over a year:",
    "baiCategories": {
      "leisureCulture": "Leisure and culture",
      "vacationsTravel": "Vacations and travel",
      "socialAid": "Social assistance",
      "internalEvents": "Internal events",
      "catering": "Catering",
      "sportsWellness": "Sports and wellness"
    },
    "whyChooseBai": "Why choose the BAI?",
    "whyChooseBaiSubtitle": "The best communication tool for Works Councils to showcase their work, strengthen transparency and employee engagement",
    "benefits": {
      "personalizedDocument": "Personalized document",
      "personalizedDocumentDesc": "Each employee receives their own report with their individual data",
      "clearVisualization": "Clear visualization",
      "clearVisualizationDesc": "Charts and figures for immediate understanding of benefits",
      "benefitsHighlight": "Benefits highlight",
      "benefitsHighlightDesc": "Concrete showcase of the purchasing power gained",
      "totalTransparency": "Total transparency",
      "totalTransparencyDesc": "Strengthens trust and understanding of Works Council actions",
      "electoralTool": "Powerful electoral tool",
      "electoralToolDesc": "Showcase the work accomplished and strengthen employee engagement"
    },
    "howItWorks": "How does it work?",
    "howItWorksSubtitle": "A simple and efficient process to showcase your Works Council actions",
    "steps": {
      "step1": "Data transmission",
      "step1Desc": "You securely transmit the employee benefits data to us",
      "step2": "BAI creation",
      "step2Desc": "We create personalized reports with your colors and visual identity",
      "step3": "Distribution",
      "step3Desc": "Each employee receives their BAI printed or in digital format"
    },
    "theyTrustUs": "They trust us",
    "theyTrustUsSubtitle": "Renowned companies trust us to showcase their Works Council actions",
    "ctaTitle": "Ready to showcase your Works Council actions?",
    "ctaSubtitle": "Contact us to discover how the BAI can transform communication",
    "ctaSubtitle2": "with your employees",
    "footerCopyright": "© 2025 1Year1Book SAS - All rights reserved",
    "banner": {
      "powerfulTool": "Very powerful communication tool",
      "optimalCommunication": "Optimal communication with employees",
      "cseWorkValorization": "Works Council work valorization",
      "teamAdhesion": "Strengthening team engagement",
      "totalTransparency": "Total transparency of benefits"
    },
    "dialog": {
      "title": "Get Started!",
      "description": "Fill out this form and our team will contact you to create your personalized BAI.",
      "nameLabel": "Full Name *",
      "namePlaceholder": "John Smith",
      "organizationLabel": "Organization *",
      "organizationPlaceholder": "Your company's Works Council",
      "phoneLabel": "Phone",
      "phonePlaceholder": "+1 234 567 8900",
      "emailLabel": "Email *",
      "emailPlaceholder": "john.smith@company.com",
      "submitButton": "Send my request",
      "submitting": "Sending...",
      "thankYouTitle": "Thank you!",
      "thankYouMessage": "Your request has been sent successfully. Our team will contact you very soon.",
      "closeButton": "Close",
      "errorRequired": "Please fill in all required fields.",
      "errorSend": "An error occurred while sending. Please try again."
    }
  },
  "ambassadors": {
    "badge": "Ambassador Program",
    "heroTitle": "Become a 1Year1Book Ambassador",
    "heroDescription": "Open doors through your network and earn an attractive commission on every Yearbook project. Zero operational constraints.",
    "becomeAmbassador": "Become an ambassador",
    "missionBadge1": "Mission 1",
    "missionBadge2": "Mission 2",
    "missionsTitle": "Your main missions",
    "missionsSubtitle": "An initiator role with no operational burden: no sales, no negotiation, no production, no follow-up.",
    "seeList": "See the list",
    "schoolsListTitle": "Establishments outside partner network",
    "missions": {
      "identify": {
        "title": "Identify",
        "description": "Contact establishments outside our partner network that might be interested in a Yearbook."
      },
      "detect": {
        "title": "Detect",
        "description": "Spot a real, structured Yearbook project for the current or upcoming year."
      },
      "connect": {
        "title": "Connect",
        "description": "Pass the qualified contact to our team who will take it from there."
      }
    },
    "whatYouDoTitle": "What you actually do",
    "whatYouDoSubtitle": "A simple 4-step process",
    "steps": {
      "contact": {
        "title": "Make contact",
        "description": "Reach out to establishments in your network"
      },
      "present": {
        "title": "Present the concept",
        "description": "Briefly explain the Yearbook"
      },
      "verify": {
        "title": "Verify criteria",
        "description": "Real interest, structured project, min. 50 copies"
      },
      "transmit": {
        "title": "Pass it to us",
        "description": "Send the qualified contact to our team"
      }
    },
    "noSaleNegotiation": "You don't get involved in sales, negotiations, or production",
    "remunerationBadge": "Attractive compensation",
    "remunerationTitle": "Progressive commission based on your results",
    "remunerationDescription": "The more projects you bring, the higher your commission rate. A transparent and motivating system.",
    "minimum50": "Minimum 50 copies per contract",
    "basedOnOrders": "Based on copies actually ordered and paid",
    "paymentAfterSignature": "Payment within 30 days after validation",
    "whyBecomeTitle": "Why become an ambassador?",
    "why": {
      "simple": {
        "title": "A simple role",
        "description": "You open doors through your network. We handle everything else."
      },
      "transparent": {
        "title": "Transparent compensation",
        "description": "Clear commission paid after each validated and paid project."
      },
      "noConstraint": {
        "title": "Zero constraints",
        "description": "No negotiations, no project follow-up, no production to manage."
      },
      "humanValue": {
        "title": "High human value project",
        "description": "Lasting memory for students, durable emotional impact."
      }
    },
    "weHandleTitle": "What we take care of",
    "weHandleSubtitle": "Once the introduction is made, our team handles the entire project.",
    "weHandle": {
      "structuring": "Precise needs assessment",
      "proposal": "Commercial and contractual proposal",
      "coordination": "Coordination with the establishment",
      "design": "Design, production, and delivery"
    },
    "validConditionsTitle": "Validation conditions",
    "validConditionsSubtitle": "A lead is considered valid if:",
    "conditions": {
      "notPartner": "The establishment is not already a partner",
      "newContact": "The contact provided is new",
      "signedContract": "The project results in a signed contract",
      "minimum50": "The order reaches at least 50 copies"
    },
    "contactTitle": "Join the program",
    "contactSubtitle": "Fill out the form and our team will contact you",
    "form": {
      "name": "Full name",
      "namePlaceholder": "John Smith",
      "email": "Email",
      "emailPlaceholder": "john.smith@email.com",
      "phone": "Phone (optional)",
      "phonePlaceholder": "+1 234 567 8900",
      "message": "Message (optional)",
      "messagePlaceholder": "Tell us about your network or ask your questions...",
      "submit": "Submit my application",
      "successTitle": "Application sent!",
      "successMessage": "Thank you for your interest. Our team will contact you very soon."
    },
    "footerRights": "All rights reserved",
    "banner": {
      "simpleRole": "Simple and rewarding role",
      "attractiveRemuneration": "Attractive compensation",
      "zeroConstraint": "Zero operational constraints",
      "humanProject": "High human value project",
      "networkOpportunity": "Network opportunity"
    }
  }
}
